import React from 'react'
import { Col, Layout, Row, Spin, theme } from 'antd'
import {
  HeaderSection,
  FinancialSummary,
  QuickActions,
  RecentActivity,
  RevenueTrends,
  NotificationsWidget
} from './components'
import useDashboardData from './hooks/useDashboardData'
import { ContainerCard } from '../../../reusable-components/AgiliteCards'
import PageHeader from '../../../reusable-components/PageHeader'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartLine } from '@fortawesome/free-solid-svg-icons'

const { Content } = Layout

const BillingDashboard = () => {
  const { loading, data, refreshData, markAllNotificationsAsRead } = useDashboardData()
  const { token } = theme.useToken()

  return (
    <ContainerCard bodyStyle={{ padding: 0 }}>
      <PageHeader title='Billing Dashboard' icon={faChartLine} />
      <div style={{ padding: '16px 24px' }}>
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <HeaderSection notifications={data.notifications} onRefresh={refreshData} />
          </Col>

          <Col span={24}>
            <Spin spinning={loading} tip='Loading dashboard data...'>
              <FinancialSummary financialSummary={data.financialSummary} />

              <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
                <Col xs={24}>
                  <QuickActions />
                </Col>
              </Row>

              <Row gutter={[24, 24]} style={{ marginTop: 24, marginBottom: 32 }}>
                <Col xs={24} lg={16}>
                  <RecentActivity recentInvoices={data.recentInvoices} upcomingPayments={data.upcomingPayments} />
                </Col>
                <Col xs={24} lg={8}>
                  <div style={{ marginBottom: 24 }}>
                    <NotificationsWidget
                      notifications={data.notifications}
                      onMarkAllRead={markAllNotificationsAsRead}
                    />
                  </div>
                  <div>
                    <RevenueTrends monthlyRevenue={data.monthlyRevenue} />
                  </div>
                </Col>
              </Row>
            </Spin>
          </Col>
        </Row>
      </div>
    </ContainerCard>
  )
}

export default BillingDashboard
